import dayjs from '@/dayjs'

import BaseNotification from '../BaseNotification'

export default class FullPaymentRequiredToSecureBooking extends BaseNotification {
  get processedMessage(): string {
    return super.processedMessage
      .replace('{payNowLink}', this.fullPaymentPath)
      .replace(
        '{paymentDueDateTime}',
        dayjs
          .utc(this.notification.data.paymentDueDateTime)
          .format('DD/MM/YYYY'),
      )
  }

  get fullPaymentPath(): string {
    return this.notification.paymentAllowed
      ? `
          <router-link
            :to="{
              name: 'newPayment',
              params: { initializeWith: 'fullPayment', id: ${this.notification.enquiryId} },
            }"
          >
            Pay now
          </router-link>.
        `
      : ''
  }

  get iconClass(): string {
    return 'sc-icon-money-box'
  }
}
